import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';

/**
 * t692u: handovers need a template. Whether one could apply for me (at this building when given); the entry points
 * ("Write a handover", the clock card, ＋ Create) only show when it does. `undefined` while loading.
 */
export function useHandoverTemplatesAvailable(locationId?: string | null, enabled = true): boolean | undefined {
  const ws = useWorkspaceId();
  const q = useQuery({ queryKey: ['scoped-forms', ws ?? '', 'handover', 'available', locationId ?? ''], queryFn: () => api.scopedFormsAvailable(ws!, 'handover', locationId),
    enabled: Boolean(ws && enabled), staleTime: 60_000 });
  return q.data?.available;
}

/** t697u: handover templates live on the Handovers page's Templates tab (the old /workforce/handover-templates redirects there). */
export const HANDOVER_TEMPLATES_TAB = '/workforce/handovers?tab=templates';
export const handoverTemplateLink = (id: string) => `${HANDOVER_TEMPLATES_TAB}&edit=${encodeURIComponent(id)}`;
